import { useCallback, useMemo } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import {
  saveFilterPreference,
  selectAllFilterPreferences,
} from '@user/store/userPreferences'
import { useSelector } from 'react-redux'
import { setUsersOrderBy } from '@user/store/users'

export const useSaveFilters = () => {
  const dispatch = useAppDispatch()

  const prefs = useSelector(selectAllFilterPreferences)

  const usersPref = useMemo(
    () => prefs.find((p) => p.type === 'users'),
    [prefs],
  )

  return useCallback(
    (orderBy: string) => {
      dispatch(
        saveFilterPreference({
          id: usersPref?.id,
          type: 'users',
          name: 'users filters',
          filter: JSON.stringify({ orderBy }),
        }),
      )
      dispatch(setUsersOrderBy(orderBy))
    },
    [dispatch, usersPref?.id],
  )
}
